import { render, staticRenderFns } from "./DepositMessage.vue?vue&type=template&id=5f97872c&"
import script from "./DepositMessage.vue?vue&type=script&lang=js&"
export * from "./DepositMessage.vue?vue&type=script&lang=js&"
import style0 from "./DepositMessage.vue?vue&type=style&index=0&id=5f97872c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports